import React from 'react';

function ReferenceLinks({ referenceLinks, title } : any) {
  return (
    <div className="flex-col justify-start my-4">
      <p className="font-bold text-[24px] tracking-[0.15em] leading-[26.5px] uppercase text-chdGreen-light mb-2 ">{title}</p>
      {referenceLinks
        .map((link: any) => <p key={link.title} className="capitalize text-[16px] leading-[22px]"><a href={link.url} target="_blank" rel="noreferrer" className="text-white hover:text-chdBlue-light opacity-90">{link.title}</a></p>)}
    </div>
  );
}

export default ReferenceLinks;
